import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { ff } from '@atlassian/jira-feature-flagging';

export type LabelProps = {
	htmlFor?: string;
	children: React.ReactNode;
};

export const Label = ({ htmlFor, children }: LabelProps) => (
	<Box
		as="label"
		htmlFor={htmlFor}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		xcss={ff('products-and-entitlements-details-m2_45b1j') ? labelStyles : oldLabelStyles}
	>
		{children}
	</Box>
);

const oldLabelStyles = xcss({
	fontWeight: 600,
	fontSize: 12,
	overflowWrap: 'anywhere',
});

const labelStyles = xcss({
	color: 'color.text.subtle',
	fontWeight: 500,
	fontSize: 12,
	overflowWrap: 'anywhere',
});
